import React, { Component } from 'react';
import zxcvbn from 'zxcvbn';
import '../../../css/password.css';

class PasswordStrengthMeter extends Component {

    createPasswordLabel = (result) => {
        switch (result.score) {
          case 0:
            return 'Very Weak';
          case 1:
            return 'Weak';
          case 2:
            return 'Fair';
          case 3:
            return 'Good';
          case 4:
            return 'Strong';
          default:
            return 'Very Weak';
        }
    }

    createPasswordFeedback = (result) => {
      let suggestions = result.feedback.suggestions;
      let warning = result.feedback.warning;

      return suggestions + " " + warning;
    }

    render() {
        const { new_password } = this.props;
        const passwordResult = zxcvbn( new_password );
        
        return (
            <div className="password-strength-meter">
                <progress className={ `password-strength-meter-progress strength-${this.createPasswordLabel(passwordResult)}` } value={ passwordResult.score } max="4" />
                <label className="password-strength-meter-label">
                    { new_password && (
                        <>
                            Password hint: <strong>{ this.createPasswordLabel( passwordResult ) }.</strong>
                            <br/><i>{ this.createPasswordFeedback( passwordResult ) }</i>
                        </>
                    )}
                </label>
            </div>
        );
    }
}

export default PasswordStrengthMeter;